import { nothing } from 'maybeasy';
import { createContext } from 'react';
import { Linkables } from '../Types';

export const LinkableContext = createContext<Linkables>(nothing());
